// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1AnU_","resendInfoText":"OnGoingPaymentBox_resendInfoText___i8Xg"};